import { Layout, Avatar, Modal, Dropdown, Button, Space } from "antd";

import { CaretDownOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import cookie from 'react-cookies'

import Hamburger from "../../../components/Hamburger";
import defaultAvatar from "../../../assets/img/avatar.gif"
import "./index.scss";



const { Header } = Layout;
const LayoutHeader = () => {
  const navigate = useNavigate()
  const { fixedHeader, sidebarCollapsed } = useSelector(state => state.switcher);

  const doLogout = (token) => {
    Modal.confirm({
      title: "注销",
      content: "确定要退出系统吗?",
      okText: "确定",
      cancelText: "取消",
      onOk: () => {
        cookie.remove('_tkn_')
        navigate('/unauthorized')
      },
    });
  };

  const computedStyle = () => {
    let styles;
    if (fixedHeader) {
      if (sidebarCollapsed) {
        styles = {
          width: "calc(100% - 80px)",
        };
      } else {
        styles = {
          width: "calc(100% - 200px)",
        };
      }
    } else {
      styles = {
        width: "100%",
      };
    }
    return styles;
  };

  return (
    <>
      {fixedHeader ? <Header /> : null}
      <Header
        style={computedStyle()}
        className={fixedHeader ? "fix-header" : ""}
      >
        <Hamburger />
        <div className="right-menu">
            <Avatar shape="square" size="medium" src={defaultAvatar} />
            <span>管理员</span>
            <Space>
              <Button type="line" onClick={doLogout}>退出</Button>
            </Space>

        </div>
      </Header>
    </>
  );
};
export default LayoutHeader;
